export default "__VITE_PUBLIC_ASSET__7a4bf163__"